/**
 * @description Takes an array of inventory filters and returns
 * an array of ids for a specified keyname
 *
 * @param {Array}  inventoryFilters   Array of inventory filters
 * @param {number} validAttributes    Array of valid attributes
 * @param {string} keyName            Name of the key to be used in the query string
 *
 * @returns {Array} An array of ids for the array of filter names for specified keyName
 */
export function convertToIDs(inventoryFilters, validAttributes, keyName) {
  if (!inventoryFilters[keyName]) return []; // if nothing comes back for the key exit early
  // Model names aren't unique so we need to make sure we get the right makeId as well
  if (keyName === "model") {
    const makeId = validAttributes.make.find(
      (attr) => attr.name === inventoryFilters?.make[0],
    )?.id;
    return inventoryFilters.model.map(
      (item) =>
        validAttributes.model.find(
          (attr) => attr.name === item && attr.makeId === makeId,
        )?.id,
    );
  }
  return inventoryFilters[keyName].map(
    (item) => validAttributes[keyName].find((attr) => attr.name === item)?.id,
  );
}

export function convertToRange(filter = []) {
  if (filter.length === 0) return;
  // This will parse 'null' to null
  const min =
    ["null", "undefined"].includes(filter[0]) || !filter[0] ? "" : filter[0];
  const max =
    ["null", "undefined"].includes(filter[1]) || !filter[1] ? "" : filter[1];
  // eslint-disable-next-line consistent-return
  return `${min}..${max}`;
}

export const convertFiltersForApi = (inventoryFilters, validAttributes) => ({
  condition: inventoryFilters.condition,
  makeId: convertToIDs(inventoryFilters, validAttributes, "make"),
  modelId: convertToIDs(inventoryFilters, validAttributes, "model"),
  bodyTypeId: convertToIDs(inventoryFilters, validAttributes, "bodyType"),
  driveTypeId: convertToIDs(inventoryFilters, validAttributes, "driveType"),
  transmissionId: convertToIDs(
    inventoryFilters,
    validAttributes,
    "transmission",
  ),
  fuelTypeId: convertToIDs(inventoryFilters, validAttributes, "fuelType"),
  exteriorColourId: convertToIDs(
    inventoryFilters,
    validAttributes,
    "exteriorColour",
  ),
  lifestyleId: convertToIDs(inventoryFilters, validAttributes, "lifestyle"),
  year: convertToRange(inventoryFilters.year),
  price: convertToRange(inventoryFilters.price),
  kilometers: convertToRange(inventoryFilters.kilometers),
  sellerType: inventoryFilters.sellerType,
  dealershipId: inventoryFilters.dealershipId,
  sortBy: inventoryFilters.sortBy
    ? inventoryFilters.sortBy[0].split(" ")[0]
    : "rank", // defaults sort to rank
  orderBy: inventoryFilters.sortBy
    ? inventoryFilters.sortBy[0].split(" ")[1]
    : "desc", // defaults sort to rank desc
});
